import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { RecollectOrderInput } from './RecollectOrderInput';
import { RecollectOrderOutput } from './RecollectOrderOutput';

export class RecollectOrderService extends HttpServiceBase {

  handle = (input: RecollectOrderInput): Promise<Result<RecollectOrderOutput> | null> => {
    const promise = this.http.put<Result<RecollectOrderOutput>, RecollectOrderInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/recollect`,
      input
    );
    return promise;
  }
}